import { abyssColors, primary } from '@/theme/colors';
import { Box, Button, Stack, Typography, alpha } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

type ButtonProps = {
  contained?: boolean;
};

export const AccordianToggleButton = muiStyled(Box)(() => ({
  width: '3.2rem',
  height: '3.2rem',
  background: primary.blue,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '0.4rem',
  color: 'white',
  cursor: 'pointer',
  '& svg': {
    transition: 'transform 0.3s',
  },
}));

export const TabPill = muiStyled(Button)(({ selected }: { selected: boolean }) => ({
  whiteSpace: 'nowrap',
  fontSize: '1.3rem',
  boxShadow: 'none',
  height: '32px',
  borderRadius: '32px',
  padding: '8px 10px',
  display: 'flex',
  alignItems: 'center',
  textTransform: 'none',
  fontWeight: '400',
  backgroundColor: selected ? abyssColors.primary[600] : alpha(primary.light, 0.2),
  color: selected ? abyssColors.neutral[50] : 'black',
  '&:hover': { backgroundColor: selected ? abyssColors.primary[600] : alpha(primary.light, 0.2) },
}));

export const DialogHeading = muiStyled(Typography)(() => ({
  fontSize: '2rem',
  lineHeight: 'normal',
  fontWeight: 500,
  color: abyssColors.primary[500],
}));

export const DialogText = muiStyled(Typography)(() => ({
  fontSize: '1.4rem',
  lineHeight: '2rem',
  color: abyssColors.primary[500],
}));

export const ProfileContainer = muiStyled(Stack)(() => ({
  position: 'relative',
  padding: '3.2rem 1.6rem',
  width: '100%',
  maxWidth: '148.8rem',
  height: '100vh',
  overflowY: 'auto',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
  gap: '0.8rem',
  alignItems: 'flex-start',
}));

export const ActionButton = muiStyled(Button)(({ contained }: ButtonProps) => ({
  padding: '0.6rem 1.6rem',
  height: '3.6rem',
  borderRadius: '0.4rem',
  fontSize: '1.4rem',
  background: contained ? abyssColors.primary[500] : abyssColors.neutral[50],
  border: contained ? 'none' : `0.1rem solid ${abyssColors.primary[500]}`,
  color: contained ? abyssColors.neutral[50] : abyssColors.primary[500],
  boxShadow: 'none',
  textTransform: 'none',
  width: 'fit-content',
  lineHeight: 'normal',
  marginLeft: '0px !important',
  gap: '0.6rem',
  '&:disabled': {
    background: contained ? abyssColors.neutral[300] : abyssColors.neutral[50],
    color: contained ? abyssColors.neutral[50] : abyssColors.primary[300],
  },
  '&:hover': {
    background: contained ? abyssColors.primary[400] : abyssColors.neutral[50],
  },
}));
